<template>
  <input
    type="text"
    :placeholder="placeholder"
    :disabled="disabled"
    :value="value"
    ref="inputNumber"
    @input="handleInput"
    @blur="$emit('custom-blur')"
    @keydown.enter.exact.prevent
    @keyup.enter.exact="$emit('custom-enter')"
    inputmode="numeric"
    class="input01"
    :maxlength="maxLength"
    autocomplete="new-password"
  />
</template>

<script>
import mixin from '@/utils/mixin';

export default {
  mixins: [mixin],
  model: {
    prop: 'value',
    event: 'custom-input',
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: 1000,
    },
  },
  methods: {
    changeSelection(value, selection) {
      if (!value) return '';
      const digit = this.removeComma(value.substring(0, selection)).toString().length;
      return parseInt(digit);
    },
    handleInput() {
      const el = this.$refs.inputNumber;
      el.oldValue = this.removeComma(el.value);
      el.oldSelectionStart = this.changeSelection(el.value, el.selectionStart);
      el.oldSelectionEnd = this.changeSelection(el.value, el.selectionEnd);
      this.$nextTick(() => {
        el.value = el.oldValue;
        el.setSelectionRange(el.oldSelectionStart, el.oldSelectionEnd);
      });

      this.$emit('custom-input', el.oldValue);
    },
  },
};
</script>
